import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';

const Wrapper = styled.div`
  position: relative;
  width: 100%;

  &&::before,
  &&::after {
    align-items: center;
    background: none;
    border: none;
    bottom: 10px;
    content: '';
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 67px;
    z-index: 1;
  }

  &&::before {
    left: 0;
    background: linear-gradient(90deg, var(--white), transparent);
    ${({ $showLeftFade }) => $showLeftFade && 'opacity: 1;'}
  }

  &&::after {
    right: 0;
    background: linear-gradient(270deg, var(--white), transparent);
    ${({ $showRightFade }) => $showRightFade && 'opacity: 1;'}
  }
`;

const ScrollContent = styled.div`
  display: flex;
  overflow: auto;
  position: relative;
  width: 100%;
`;

const EndCap = styled.div`
  background-color: transparent;
  min-width: 1px;
`;
const LeftEndCap = styled(EndCap)``;
const RightEndCap = styled(EndCap)``;

const HorizontalScroll = ({ children }) => {
  const [leftRef, leftInView] = useInView();
  const [rightRef, rightInView] = useInView();

  return (
    <Wrapper $showRightFade={!rightInView} $showLeftFade={!leftInView}>
      <ScrollContent>
        <LeftEndCap ref={leftRef} />
        {children}
        <RightEndCap ref={rightRef} />
      </ScrollContent>
    </Wrapper>
  );
};

HorizontalScroll.propTypes = {
  children: PropTypes.node,
};

export default styled(HorizontalScroll)``;
